export default __webpack_public_path__ + "static/jedzenie-274d5f5d133babcfa2d39b0f1cf159d0.png";